import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, IconButton, Divider, Stack } from "@mui/material";
import BaseDrawer from "../../UI/BaseDrawer/BaseDrawer";
import BaseButton from "../../UI/BaseButton/BaseButton";
import { profileChangePIN } from "../../../util/API/passwordpinchange";
import { useSelector } from "react-redux";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import PinPad from "../../PinPad/PinPad";
import { sendEmailPIN, SendNewPINSMS } from "../../../util/API/passwordpinchange";
import { countries } from "../../../constants/countrylist";

function PasswordChange({ open, handleCloseModal }) {
  const [showPinPad, setShowPinPad] = useState(false);
  const [pin, setPin] = useState({
    oldpin: ["", "", "", ""],
    pin: ["", "", "", ""],
    confirmpin: ["", "", "", ""]
  });
  const [visible, setVisible] = useState({
    pin: false,
    confirmpin: false,
  });
  const [alert, setAlert] = useState(
    {
      showAlert: false,
      severity: "error",
      header: "",
      message: "",
      confirmButton: null,
      alertType: ''
    }
  )

  useEffect(() => {
    setPin({
      oldpin: ["", "", "", ""],
      pin: ["", "", "", ""],
      confirmpin: ["", "", "", ""],
    })
  }, [open])

  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body
  console.log(agent)

  let storedPIN = sessionStorage.getItem("pin");
  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);
  const defaultLogin = useSelector((state) => state.login.defaultLogin);
  const loginType = useSelector((state) => state.login.loginType);
  let isOperator = sessionStorage.getItem("isOperator") === 'true';

  console.log(defaultLogin, loginType);

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    submitPIN(event, PIN);
    setShowPinPad(false);
  };

  const toggleVisibility = (key) => {
    setVisible((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && pin[index] === "" && index > 0) {
      document.getElementById(`pin-input-${index - 1}`).focus();
    }
  };

  const handleSaveClick = () => {

    if (pin.oldpin.some(digit => digit === "") || pin.pin.some(digit => digit === "") || pin.confirmpin.some(digit => digit === "")) {
      setAlert({
        ...alert,
        showAlert: true,
        severity: "error",
        message: "Please fill in all the PIN fields.",
        header: "Error!",
        alertType: "",
        confirmButton: null,
      });
      return;
    }

    if (pin?.pin?.join('') !== pin?.confirmpin?.join('')) {
      setAlert({
        ...alert,
        showAlert: true,
        severity: "error",
        message: "PIN does not match",
        header: "Error!",
        alertType: '',
        confirmButton: null
      });
      return;
    }
    setShowPinPad(true);
  }

  const cleanPhoneNumber = (phoneNumber, countryID) => {

    const country = countries.filter((c) => c.flag === countryID);

    console.log(country)
  
    if (country && country[0]?.areaCode !== "na") {
      const prefix = `${country[0]?.areaCode}`;
      if (phoneNumber.startsWith(prefix)) {
        return phoneNumber.replace(prefix, "");
      }
    }
  
    return phoneNumber;
  };

  const submitPIN = async(event, PIN) => {
    try {
      const response = await profileChangePIN(
        agent['Useremailaccount'].emailAccount,
        pin.pin.join(''),
        PIN,
        agent['User'].id
      );

      if (response?.callStatus === "1") {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "PIN changed successfully",
          alertType: '',
          confirmButton: null
        })

        if (pinConfiguration === "once") {
          sessionStorage.setItem("pin", pin.pin);
        }

        setPin({
          oldpin: ["", "", "", ""],
          pin: ["", "", "", ""],
          confirmpin: ["", "", "", ""],
        })
      }

      else {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "error",
          header: "Error",
          message: response?.payload?.msg,
          alertType: '',
          confirmButton: null
        })
      }
    }
    catch (error) {
      console.log(error)
    }
  }

  const handleEmailPINClick = () => {

    setAlert({
      ...alert,
      showAlert: true,
      severity: "confirm",
      header: "Confirm",
      message: "Would you like to proceed?",
      alertType: 'confirm',
      confirmButton: () => sendEmailPin()
    })

  }

  const sendEmailPin = async() => {

    try {

      const response = await sendEmailPIN(
        agent['User'].other1,
        agent['Useremailaccount'].emailAccount,
        agent['User'].id,
        agent['User'].franchiseeID,
        agent['User'].telephoneno,
        agent['User'].countryid,
      )

      console.log(response)

      if (response?.callStatus === "1") {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "success",
          header: "Success",
          message: response?.msg,
          alertType: '',
          confirmButton: null
        })
      }

      else {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "error",
          header: "Error",
          message: response?.payload?.data?.header?.msg,
          alertType: '',
          confirmButton: null
        })
      }

    }
    catch (error) {
      console.log(error)
    }

  }

  const handleSMSPINClick = () => {
    setAlert({
      ...alert,
      showAlert: true,
      severity: "confirm",
      header: "Confirm",
      message: "Would you like to proceed?",
      alertType: 'confirm',
      confirmButton: () => sendSMSPin()
    })
  }

  const sendSMSPin = async() => {
    try {
      const response = await SendNewPINSMS(
        defaultLogin,
        agent['User'].id,
        agent['User'].langID,
        agent['User'].countryid,
        agent['User'].franchiseeID,
      )

      console.log(response)

      if (response && response?.payload?.data?.header?.callStatus === "1") {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "SMS sent successfully",
          alertType: '',
          confirmButton: null
        })
      }

      else {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "error",
          header: "Error",
          message: response?.payload?.data?.header?.msg || "An error occured. Please check if the country code matches the phone number and try again.",
          alertType: '',
          confirmButton: null
        })
      }


    }
    catch (error) {
      console.log(error)
    }
  }

  const handlePINChange = (value, index, key) => {
    if (isNaN(value)) return; // Allow only numeric input
    setPin((prev) => {
      const updatedPin = { ...prev };
      const updatedArray = [...updatedPin[key]]; // Get the current pin array
      updatedArray[index] = value; // Update the specific digit
      updatedPin[key] = updatedArray; // Update the specific key
      return updatedPin;
    });
  
    // Move focus to the next input box
    if (value && index < pin[key].length - 1) {
      document.getElementById(`${key}-input-${index + 1}`).focus();
    }
  };

  const renderPinFields = (key, label) => (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, marginBottom: 2 }}>
      <Typography variant="caption text" sx={{ width: "80px", fontSize: "10px", color: "grey", font: "Nunito" }}>
        {label}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {pin[key].map((digit, index) => (
          <TextField
            key={index}
            id={`${key}-input-${index}`}
            value={digit}
            onChange={(e) => handlePINChange(e.target.value, index, key)}
            onKeyDown={(e) => handleBackspace(e, index)}
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: "center",
                fontSize: "20px",
                padding: "10px",
              },
            }}
            type={visible[key] ? "text" : "password"}
            variant="outlined"
            sx={{
              width: "50px",
              height: "50px",
              "& .MuiOutlinedInput-root": {
                padding: 0,
              },
            }}
          />
        ))}
        <IconButton onClick={() => toggleVisibility(key)}>
          {visible[key] ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </Box>
    </Box>
  );

  console.log(pin)

  return (
    <BaseDrawer open={open} handleClose={handleCloseModal} height="80vh" title={"Change PIN"}>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

        <Box
          sx={{
            p: 3,
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: 0.2,
            gap: 2,
            display: "flex",
            flexDirection: "column",
            width: "50%", // Ensures the form is centered and takes up a specific width
            alignItems: "center", // Centers the textfields horizontally
          }}
        >

          {renderPinFields("oldpin", "Old PIN")}
          {renderPinFields("pin", "New PIN")}
          {renderPinFields("confirmpin", "Retype PIN")}

          <Box sx={{ display:"flex", gap:2 }}>
            <BaseButton 
              buttonText="Save" 
              onClick={(e) => storedPIN ? submitPIN(e, pin) : pinConfiguration === "never" ? submitPIN(e, '0000') : handleSaveClick()}  
            />
            <BaseButton 
              buttonText="Exit" 
              onClick={(e) => handleCloseModal()}  
            />
          </Box>

          <Divider sx={{ my: 2, border: "1px solid #A6A6A6", width: "100%" }} />

          <Stack direction="row" spacing={1} alignItems="center">
            {loginType === 'email' && <BaseButton 
              buttonText="Generate PIN using Email" 
              onClick={(e) => handleEmailPINClick()}  
            />}

            {(isOperator || (loginType === 'mobile')) && <BaseButton 
              buttonText="Generate PIN using SMS" 
              onClick={(e) => handleSMSPINClick()}  
            />}
          </Stack>

        </Box>
      </Box>
      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={() => {setAlert({ ...alert, showAlert: false })}}
        alertType={alert.alertType}
        confirmButton={alert.confirmButton}
        autoclose={alert.severity === "error" ? false : true}
      />

      {showPinPad && <PinPad show={showPinPad} handleConfirm={handleConfirm} onClick={() => setShowPinPad(false)} />}
    </BaseDrawer>
  );
}

export default PasswordChange;
